"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preview = void 0;

var _react = _interopRequireDefault(require("react"));

var _usePreview = require("./usePreview");

var _Context = require("./Context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Preview = props => {
  const result = (0, _usePreview.usePreview)();

  if (!result.display) {
    return null;
  }

  const {
    display: _display,
    ...data
  } = result;
  let child;

  if ('children' in props) {
    if (typeof props.children === 'function') {
      child = props.children(data);
    } else {
      child = props.children;
    }
  } else {
    child = props.generator(data);
  }

  return /*#__PURE__*/_react.default.createElement(_Context.Context.Provider, {
    value: data
  }, child);
};

exports.Preview = Preview;